<template>
  <div></div>
</template>

<script setup>
import { onMounted } from "vue";

/*eslint-disable*/

// export default {
//   name: "ChatWoot",
//   mounted() {
//     (function (d, t) {
//       var BASE_URL = "https://app.chatwoot.com";
//       var g = d.createElement(t),
//         s = d.getElementsByTagName(t)[0];
//       g.src = BASE_URL + "/packs/js/sdk.js";
//       g.async = true;
//       s.parentNode.insertBefore(g, s);
//       g.onload = function () {
//         window.chatwootSDK.run({
//           websiteToken: "FEENJSCGJYuXa8m2EE9o5w9g",
//           baseUrl: BASE_URL,
//         });
//       };
//     })(document, "script");
//   },
// };

onMounted(() => {
  (function (d, t) {
    var BASE_URL = "https://app.chatwoot.com";
    var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    g.src = BASE_URL + "/packs/js/sdk.js";
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: "KgkcESoMRJTVChLofFHRAeY6",
        baseUrl: BASE_URL,
      });
    };
  })(document, "script");
});
</script>
